import React from 'react'
import {
  Table as MuiTable,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Box,
} from '@mui/material'
import ErrorMessage from '../../component/shared/component/ErrorMessage'
import Row from './Row'
import { LoadingSkeletonRows } from '../shared/LoadingSkeletonRows'
import Import from './Import'
import { useGetCP58 } from '../../api/cp-58'

const Table = ({ year, open, setOpen }) => {
  const { data = [], isLoading, refetch } = useGetCP58({ year })

  return (
    <Box>
      {data.length || isLoading ? (
        <>
          <TableContainer component={Paper}>
            <MuiTable size='small'>
              <TableHead>
                <TableRow>
                  <TableCell>Year</TableCell>
                  <TableCell>Company</TableCell>
                  <TableCell>Htg</TableCell>
                  <TableCell />
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <LoadingSkeletonRows rows={10} length={5} />
                ) : (
                  data.map((e, i) => <Row key={e._id} data={e} refetch={refetch}></Row>)
                )}
              </TableBody>
            </MuiTable>
          </TableContainer>
        </>
      ) : (
        <ErrorMessage empty />
      )}
      <Import open={open} setOpen={setOpen} refetch={refetch} />
    </Box>
  )
}

export default Table
